import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  TargetDateSeriesScorecardRow,
  TargetDateSeriesFundDetails
} from '../../components'

const Styles = require('./TargetDateSeriesFullScorecard.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesFullScorecard extends Component {
  static propTypes = {
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { targetDateSeries } = this.props

    return (
      <div styleName='full-scorecard card'>
        <div styleName='scorecard-header'>
          <b>Environmental</b> scorecard
        </div>
        {
          ['fff', 'dff'].map((e, i) => {
            return (
              <TargetDateSeriesScorecardRow
                key={'scrd-lnk-e-' + i}
                iyvCode={e}
                targetDateSeries={targetDateSeries}
              />
            )
          })
        }
        <div styleName='scorecard-header'>
          <b>Social</b> scorecard
        </div>
        {
          ['gef', 'gff', 'pff', 'wff', 'tff'].map((e, i) => {
            return (
              <TargetDateSeriesScorecardRow
                key={'scrd-lnk-s-' + i}
                iyvCode={e}
                targetDateSeries={targetDateSeries}
              />
            )
          })
        }

        { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
        { /*   Button and slidedown with details about the target   */ }
        { /*     date series.                                       */ }
        { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
        <TargetDateSeriesFundDetails
          targetDateSeries={targetDateSeries}
        />

      </div>
    )
  }
}